module.exports = __webpack_public_path__ + "img/2.877f9f45.jpg";